import React from "react";
import { FormProvider } from "react-hook-form";
import { Box, Button, Typography, Divider } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ControlledTextField } from "../../components/ControlledTextField";
import ControlledRadioGroup from "./ControlledRadioGroup";
import ControlledPreparednessRating from "./ControlledPreparednessRating";
import ControlledSubjectiveFeedback from "./ControlledSubjectiveFeedback";
import { useSimulationFeedback } from "./useSimulationFeedback";

const SimulationFeedback = () => {
  const { form, handleSubmit, isSubmitting } = useSimulationFeedback();
  const navigate = useNavigate();
  const { sim_id, chat_id } = useParams();

  const onSubmit = (data: any) => {
    handleSubmit(data);
  };

  const handleSkip = () => {
    // Navigate directly to transcript page when skipping feedback
    navigate(`/sim/${sim_id}/${chat_id}/transcript`);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box
          display="flex"
          flexDirection="column"
          gap={6}
          p={4}
          justifyContent="center"
          alignItems="center"
          width="100%"
          maxWidth="800px"
          mx="auto"
        >


          <ControlledPreparednessRating />

          <Divider sx={{ width: "100%", my: 2 }} />

          <ControlledSubjectiveFeedback />

          <Divider sx={{ width: "100%", my: 2 }} />


          <Box display="flex" gap={2} sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              sx={{ minWidth: "120px" }}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
            <Button
              variant="outlined"
              onClick={handleSkip}
              disabled={isSubmitting}
              sx={{ minWidth: "120px" }}
            >
              Skip
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default SimulationFeedback;
